// Prefixed so rows of different collections don't share react-admin's expanded-row store key.
export const toRows = (prefix, items = []) =>
  items.map((item, index) => ({ ...item, id: `${prefix}#${index}`, rowIndex: index }));

// The synthetic keys must not reach the wire.
export const stripRowMeta = ({ id, rowIndex, ...rest }) => rest;
